import { CampaignsApi } from '../clients';

/**
 * One promo code's uptake figures for the detail page.
 *
 * The response is already the shape the page reads — five integers/dollars —
 * so only the defaults are applied here: a key the service did not send reads
 * as 0 rather than as `undefined` in a heading.
 */
export const getPromoCodeReport = async (campaignId) => {
  const data = (await CampaignsApi.getCampaignReport(campaignId)) ?? {};

  return {
    redemptions: Number(data.redemptions) || 0,
    offices: Number(data.offices) || 0,
    totalDiscount: Number(data.totalDiscount) || 0,
    optIns: Number(data.optIns) || 0,
    optInsUnused: Number(data.optInsUnused) || 0,
  };
};
